import { Badge } from '@chain-zen/ui'
import React from 'react'

import type { EquipmentTypeEnum } from '../../types/equipment'
import { formatWeight } from '../../utils/common'
import { getTruckType, mapColorSchemeToTailwindClass } from '../../utils/shipment'

interface ICommodityStopCountWeightColumn {
  dropsCount: number | null
  picksCount: number | null
  truckTypes: EquipmentTypeEnum[] | null
  weight: {
    unit: string
    value: number
  } | null
}

const CommodityStopCountWeightColumn = (props: ICommodityStopCountWeightColumn) => {
  const { truckTypes, dropsCount, picksCount, weight } = props

  const drops = dropsCount === 1 ? '1 Drop' : `${dropsCount} Drops`
  const picks = picksCount === 1 ? '1 Pick' : `${picksCount} Picks`
  const weightInfo = weight ? formatWeight(weight.value, weight.unit) : ''

  return (
    <div className="flex flex-col gap-2">
      <span className="font-medium">{weightInfo}</span>

      <div className="flex flex-wrap gap-2">
        {truckTypes?.map((truck, index) => {
          const truckType = getTruckType(truck)
          if (!truckType) return null

          return (
            <Badge
              key={index}
              variant="secondary"
              className={`truncate ${
                mapColorSchemeToTailwindClass[truckType.colorScheme] || mapColorSchemeToTailwindClass.gray
              }`}
            >
              {truckType.label}
            </Badge>
          )
        })}
      </div>

      <span className="text-sm text-gray-600 dark:text-gray-400">
        {!!picksCount && picks}
        {!!picksCount && !!dropsCount && ', '}
        {!!dropsCount && drops}
      </span>
    </div>
  )
}

export { CommodityStopCountWeightColumn }
